// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentProps } from 'react';
import AppRouter from './AppRouter';
import './styles/reset.scss';
import './App.css';
import ErrorImg from './assets/images/pic_error_internet.svg';
import styled from 'styled-components';
import Column from './components/Column';
import Button from './components/Button';
import { FormattedMessage } from 'react-intl';

type ErrorState = { hasError: boolean }

const S = {
  Container: styled(Column)`
    height: 100%;

    > * + * {
      margin-top: 36px;
    }
  `,
  P: styled.p`
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
  `,
  Retry: styled.a`
    color: #EF8200;
    cursor: pointer;
    text-decoration-line: underline;
    text-underline-offset: 2px;
  `,
  Img: styled.img``,
  Button: styled(Button)`
    width: 142px;
    height: 44px;
  `
}

function ErrorPage(): JSX.Element {
  const retry = () => {
    window.location.reload();
  }

  return (
    <S.Container alignX="center" alignY="center">
      <S.Img src={ErrorImg} alt="" />
      <S.P>
        <FormattedMessage id="B031" values={{here: <S.Retry onClick={retry}><FormattedMessage id="B031-1"/></S.Retry>, br: <br/>}}/>
      </S.P>
      <S.Button as="a" href="/home"><FormattedMessage id="B032"/></S.Button>
    </S.Container>
  )
}

class App extends React.Component<ComponentProps<'div'>, ErrorState> {
  state: ErrorState = { hasError: false };

  static getDerivedStateFromError(error: any): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.log('error', { error, errorInfo })
  }

  render(): JSX.Element {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return (
      <AppRouter />
    );
  }
}

export default App;
